import React from 'react';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import { StyledAutoComplete } from 'components/AutoCompleteFilter/styles';

const AutoComleteFilter = (props: any) => {
  const {
    name,
    options,
    isLoading,
    setFieldValue,
    getItems,
    label,
    placeholder,
    value,
  } = props;

  const [itemName, SetItemName] = React.useState('');

  React.useEffect(() => {
    if (itemName) getItems(itemName);
    // eslint-disable-next-line
  }, [itemName]);

  return (
    <StyledAutoComplete
      id="item-autocomplete"
      getOptionSelected={(item: any, value: any) => item.name === value.name}
      getOptionLabel={(item: any) => item.name}
      options={options}
      loading={isLoading}
      onChange={(event: any, newValue: any) => {
        setFieldValue(name, newValue);
      }}
      value={value}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={placeholder}
          label={label}
          variant="outlined"
          name={name}
          onChange={(e: any) => {
            SetItemName(e.target.value);
          }}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {isLoading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
};

export default AutoComleteFilter;
